import React, { useEffect, useState, useRef } from "react";
import Flexbox from "flexbox-react";
import { inject, observer } from "mobx-react";
import { Icon } from "@blueprintjs/core";

import "./GoalReportPage.css";


const GoalReportDataCard = inject("ToastStore")(
  observer(({ card }) => {
    const { keyName, title, data, icon, info, timeCardText, goalCycleStatus, currentScenario } = card;

    const getInfoTextAndColor = () => {
      if (keyName === "time_left") {
        if (currentScenario === "Upcomming") return { text: timeCardText, color: "#3B82F6" }; // Blue
        if (currentScenario === "Ongoing") return { text: timeCardText, color: "#F59E0B" }; // Orange
        if (currentScenario === "Ended") return { text: timeCardText, color: "#22C55E" }; // Green
      } else {
        if (currentScenario === "Upcomming") {
          return { text: "No goals submitted yet", color: "#9CA3AF" }; // Grey for Not Started
        } else {
          return { text: info || "", color: "#9CA3AF" }; // Default Grey for others
        }
      }

      // ====> DEFAULT fallback to prevent undefined destructuring
      return { text: "", color: "#000000" };
    };

    const { text, color } = getInfoTextAndColor();

    const getDynamicIcon = () => {
      if (keyName === "time_left") {
        if (goalCycleStatus === "Not_Started") {
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path
              d="M8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15Z"
              stroke="#3B82F6"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path d="M8 3.80005V8.00005L10.8 9.40005" stroke="#3B82F6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
          </svg>;
        }
        if (goalCycleStatus === "Ongoing") {
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="16" viewBox="0 0 18 16" fill="none">
            <path
              d="M8.99967 11.7519H9.00702M8.99967 6.18382V8.96788M7.6903 1.74511L1.20501 12.68C1.07138 12.9138 1.00071 13.179 1.00001 13.449C0.999302 13.7191 1.0686 13.9846 1.201 14.2192C1.3334 14.4538 1.5243 14.6493 1.75471 14.7863C1.98512 14.9233 2.24702 14.9969 2.51438 15H15.485C15.7524 14.9972 16.0145 14.9237 16.2451 14.7868C16.4756 14.6499 16.6667 14.4543 16.7991 14.2196C16.9316 13.9849 17.0008 13.7193 17 13.4491C16.9992 13.179 16.9282 12.9138 16.7943 12.68L10.31 1.74511C10.1736 1.51768 9.98141 1.32962 9.75204 1.1991C9.52267 1.06857 9.26386 1 9.00059 1C8.73732 1 8.4785 1.06857 8.24913 1.1991C8.01977 1.32962 7.82761 1.51768 7.69122 1.74511"
              stroke="#F59E0B"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>;
        }
        if (goalCycleStatus === "Ended") {
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path
              d="M14.859 6.60238C15.1787 8.17129 14.9509 9.80237 14.2135 11.2236C13.4762 12.6449 12.2739 13.7704 10.8071 14.4125C9.34035 15.0546 7.69779 15.1744 6.15336 14.752C4.60894 14.3296 3.25599 13.3906 2.32015 12.0914C1.38431 10.7922 0.922146 9.21144 1.01073 7.61275C1.0993 6.01405 1.73328 4.49404 2.80691 3.3062C3.88055 2.11836 5.32896 1.33449 6.9106 1.0853C8.49224 0.836119 10.1115 1.13669 11.4983 1.93688"
              stroke="#22C55E"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M5.89844 7.30234L7.99844 9.40234L14.9984 2.40234"
              stroke="#22C55E"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>;
        }
      }
      return icon;
    };

    const getTimeCardDynamicIcon = () => {
      if (keyName === "time_left") {
        if (currentScenario === "Upcomming") {
        return  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path d="M8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15Z" stroke="#3B82F6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M8 3.80005V8.00005L10.8 9.40005" stroke="#3B82F6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>;
        }
        if (currentScenario === "Ongoing") {
        return  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="16" viewBox="0 0 18 16" fill="none">
  <path d="M8.99967 11.7519H9.00702M8.99967 6.18382V8.96788M7.6903 1.74511L1.20501 12.68C1.07138 12.9138 1.00071 13.179 1.00001 13.449C0.999302 13.7191 1.0686 13.9846 1.201 14.2192C1.3334 14.4538 1.5243 14.6493 1.75471 14.7863C1.98512 14.9233 2.24702 14.9969 2.51438 15H15.485C15.7524 14.9972 16.0145 14.9237 16.2451 14.7868C16.4756 14.6499 16.6667 14.4543 16.7991 14.2196C16.9316 13.9849 17.0008 13.7193 17 13.4491C16.9992 13.179 16.9282 12.9138 16.7943 12.68L10.31 1.74511C10.1736 1.51768 9.98141 1.32962 9.75204 1.1991C9.52267 1.06857 9.26386 1 9.00059 1C8.73732 1 8.4785 1.06857 8.24913 1.1991C8.01977 1.32962 7.82761 1.51768 7.69122 1.74511" stroke="#F59E0B" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
</svg>;
        }
        if (currentScenario === "Ended") {
        return  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
  <path d="M14.859 6.60238C15.1787 8.17129 14.9509 9.80237 14.2135 11.2236C13.4762 12.6449 12.2739 13.7704 10.8071 14.4125C9.34035 15.0546 7.69779 15.1744 6.15336 14.752C4.60894 14.3296 3.25599 13.3906 2.32015 12.0914C1.38431 10.7922 0.922146 9.21144 1.01073 7.61275C1.0993 6.01405 1.73328 4.49404 2.80691 3.3062C3.88055 2.11836 5.32896 1.33449 6.9106 1.0853C8.49224 0.836119 10.1115 1.13669 11.4983 1.93688" stroke="#22C55E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M5.89844 7.30234L7.99844 9.40234L14.9984 2.40234" stroke="#22C55E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
        }
      }
      return icon;
    };

    return (
      <Flexbox flexGrow={1}>
        <Flexbox flexDirection="column" className="report-card-box">
          <p className="report-card-title">{title}</p>
          <Flexbox flexDirection="row" alignItems="center" justifyContent="space-between" style={{ minHeight: "60px" }}>
            <p className="report-card-data">{data}</p>
            <p>{getDynamicIcon()}</p>
          </Flexbox>
         
          <p className="report-card-info" style={{ color: color }}>
        {/* {keyName === "time_left" && getTimeCardDynamicIcon()}  */}
        <span>{text}</span>
          </p>
        </Flexbox>
      </Flexbox>
    );
  })
);

export default GoalReportDataCard;
